module.exports = __webpack_public_path__ + "img/chart_example.7d619068.png";